<template>
  <loading-view :loading="loading">
    <div class="container mx-6 mt-4">
      <!-- Update Profile Photo -->
      <div class="tile mb-8">
        <profile-form :user="user" :locales="locales"/>
      </div>

      <!-- Update Contact Information -->
      <div class="tile mb-8">
        <profile-contact-information-form :user="user"/>
      </div>

      <!-- Update Billing Address -->
      <div class="tile mb-8">
        <profile-billing-address-form :user="user" :countries="countries"/>
      </div>

      <!-- Two-factor authentication -->
      <div class="tile mb-8">
        <two-factor-authentication-form class="mt-10 sm:mt-0" :requires-confirmation="true"/>
      </div>

      <!-- Delete Account -->
      <div class="tile mb-8">
        <profile-delete-account-form :user="user"/>
      </div>
    </div>
  </loading-view>
</template>

<script>
import axios from "axios";
import DashboardLayout from "@/Layouts/DashboardLayout";
import ProfileForm from "@/Pages/Dashboard/Account/Partials/Profile/Form";
import ProfileContactInformationForm from "@/Pages/Dashboard/Account/Partials/Profile/ContactInformationForm";
import ProfileBillingAddressForm from "@/Pages/Dashboard/Account/Partials/Profile/BillingAddressForm";
import TwoFactorAuthenticationForm from "@/Pages/Dashboard/Account/Partials/TwoFactorAuthenticationForm";
import ProfileDeleteAccountForm from "@/Pages/Dashboard/Account/Partials/Profile/DeleteAccountForm";

export default {
  name: "Profile",

  layout: DashboardLayout,

  components: {
    ProfileForm,
    ProfileBillingAddressForm,
    ProfileContactInformationForm,
    TwoFactorAuthenticationForm,
    ProfileDeleteAccountForm
  },

  props: {
    user: Object,
    locales: Array
  },

  data() {
    return {
      loading: true,
      countries: []
    }
  },

  async beforeMount() {
    await this.fetchCountries()

    this.loading = false
  },

  methods: {
    async fetchCountries() {
      await axios.get(this.$route('countries')).then(({data}) => {
        this.countries = data.data.countries
      })
    }
  },
}
</script>
